import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useHasCompletedPaymentsApplication from '../commercePayment/hooks/useHasCompletedPaymentsApplication';
import GoToPaymentsButtonWrapper from 'payments-embed-points-lib/components/GoToPaymentsButtonWrapper';
import { UnderwritingStatus } from 'growth-payments-core/eligibility/types';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { Screen, Subscreen } from 'payments-embed-points-lib/types/screen';
import { trackHover } from 'payments-embed-points-lib/tracking/track';
import { translateObjectName } from 'customer-data-objects/record/translateObjectName';
import EmbedPointContextProvider from 'payments-embed-points-lib/components/EmbedPointContextProvider';
import { useCommerceHomeUrl } from '../../hooks/usePaymentHooks';
import { calculateKYCStatus, hasCompletedUnderwritingReview } from 'growth-payments-core/eligibility/utils';
import { Flex } from 'foundations-components/components/Flex';
import Skeleton from '../../../chicklets/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  PAYMENT_LINK_EMPTY_STATE_TEST_ID: 'associated-objects-card-empty-state',
  ORIGINAL_PAYMENT_LINK_MESSAGE_TEST_ID: 'associated-objects-card-payment-link-empty-state-message',
  PAYMENT_LINK_MESSAGE_TEST_ID: 'associated-objects-card-payment-link-empty-state-message-alt',
  PAYMENTS_SETUP_BUTTON_TEST_ID: 'associated-objects-card-payment-link-empty-state-setup-button'
};
export const PAYMENT_LINK_SETUP_CTA_MESSAGE = {
  SETUP_PAYMENTS_MESSAGE: 'cardAssociatedObjects.emptyState.PAYMENT_LINK.setup',
  SETUP_PENDING_MESSAGE: 'cardAssociatedObjects.emptyState.GENERIC.paymentsSetupPending'
};
const getMessage = underwritingStatus => {
  switch (underwritingStatus) {
    case UnderwritingStatus.IN_UNDERWRITING:
      return PAYMENT_LINK_SETUP_CTA_MESSAGE.SETUP_PENDING_MESSAGE;
    default:
      return PAYMENT_LINK_SETUP_CTA_MESSAGE.SETUP_PAYMENTS_MESSAGE;
  }
};
const PaymentLinksPaymentsDiscoveryPoint = ({
  fromObjectTypeId
}) => {
  const href = useCommerceHomeUrl();
  const handleTrackSetupPayments = useCallback(() => {
    CrmLogger.logImmediate('sidebar-interaction', {
      action: 'clicked set up Payments',
      subAction: 'navigate to Payments zero state from Payment Links',
      fromObjectType: translateObjectName(fromObjectTypeId)
    });
  }, [fromObjectTypeId]);
  const handleOnMouseEnter = e => {
    trackHover({
      screen: Screen.CRM
    }, e);
  };
  return /*#__PURE__*/_jsx(EmbedPointContextProvider, {
    screen: Screen.CRM,
    subscreen: Subscreen.CRM_PAYMENT_LINKS,
    children: ({
      handlePaymentsInterstitialModalOpen
    }) => /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(GoToPaymentsButtonWrapper, {
          page: Screen.CRM,
          location: Subscreen.CRM_PAYMENT_LINKS,
          use: "tertiary-light",
          size: "small",
          onClick: handlePaymentsInterstitialModalOpen(handleTrackSetupPayments),
          href: href,
          "data-selenium-test": TEST_IDS.PAYMENTS_SETUP_BUTTON_TEST_ID,
          "data-test-id": TEST_IDS.PAYMENTS_SETUP_BUTTON_TEST_ID,
          onMouseEnter: handleOnMouseEnter
        })
      })
    })
  });
};
const PaymentLinkCardEmptyState = ({
  fromObjectTypeId,
  cardId,
  numberOfProperties
}) => {
  const {
    loading,
    underwritingStatus
  } = useHasCompletedPaymentsApplication();
  const shouldShowDiscoveryPoint = !hasCompletedUnderwritingReview(calculateKYCStatus(underwritingStatus));
  if (loading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      cardId: cardId,
      numberOfProperties: numberOfProperties
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-test": TEST_IDS.PAYMENT_LINK_EMPTY_STATE_TEST_ID,
    "data-test-id": TEST_IDS.PAYMENT_LINK_EMPTY_STATE_TEST_ID,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      "data-selenium-test": TEST_IDS.PAYMENT_LINK_MESSAGE_TEST_ID,
      "data-test-id": TEST_IDS.PAYMENT_LINK_MESSAGE_TEST_ID,
      message: getMessage(underwritingStatus)
    }), shouldShowDiscoveryPoint && /*#__PURE__*/_jsx(PaymentLinksPaymentsDiscoveryPoint, {
      fromObjectTypeId: fromObjectTypeId
    })]
  });
};
export default PaymentLinkCardEmptyState;